<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.page')"
    namespace="/"
    resource="pages"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TAG_TYPE, PAGE_STATUS } from '@/constants';
import _ from 'lodash';

@Component
export default class Pages extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'title_cont',
        label: this.$t('page.title'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'slug_cont',
        label: this.$t('page.slug'),
        renderCell: {
          component: 'input'
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id')
      },
      {
        prop: 'title',
        label: this.$t('page.title'),
      },
      {
        prop: 'slug',
        label: this.$t('page.slug'),
      },
      {
        prop: 'type',
        label: this.$t('page.presetPage'),
        renderCell: (h, { props: { value } }) => {
          let tagType
          let text

          if (value === 'PresetPage') {
            tagType = 'success'
            text = this.$t('bean.yes')
          } else {
            tagType = 'danger'
            text = this.$t('bean.no')
          }

          return <el-tag type={tagType}>{text}</el-tag>;
        }
      },
      {
        prop: 'status',
        label: this.$t('page.status'),
        renderCell: (h, { props: { value } }) => {
          return <el-tag type={TAG_TYPE[value]}>{ this.$t(`page.statuses.${value}`) }</el-tag>;
        }
      },
      type === 'show' && {
        prop: 'mini_program_path',
        label: this.$t('page.miniProgramPath'),
      },
      type === 'show' && {
        prop: 'content',
        label: this.$t('page.content'),
        renderCell: 'html'
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { html, data, type } = {}) {
    return [
      {
        prop: 'title',
        label: this.$t('page.title'),
        renderCell: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'slug',
        label: this.$t('page.slug'),
        renderCell: {
          component: 'input',
          required: true,
          hint: this.$t('hints.disallowEditAfterCreate'),
          props: {
            disabled: type === 'edit'
          }
        }
      },
      data.type !== 'PresetPage' && {
        prop: 'status',
        label: this.$t('page.status'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            options: _.map(PAGE_STATUS, (value) => ({ label: this.$t(`page.statuses.${value}`), value }))
          }
        }
      },
      {
        prop: 'content',
        label: this.$t('page.content'),
        renderCell: {
          required: true,
          component: 'editor',
          props: {
            html
          }
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'pages.edit', params: { id: row.id } }
        }
      },
      row.type === 'StaticPage' && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'pages.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/pages',
    name: 'pages.index',
    component: Pages,
    props: {
      type: 'index',
    }
  },
  {
    path: '/pages/new',
    name: 'pages.new',
    component: Pages,
    props: {
      type: 'new',
    }
  },
  {
    path: '/pages/:id',
    name: 'pages.show',
    component: Pages,
    props: {
      type: 'show',
    }
  },
  {
    path: '/pages/:id/edit',
    name: 'pages.edit',
    component: Pages,
    props: {
      type: 'edit'
    }
  }
]
</script>
